// Product-card quick-add-to-cart. Mirrors the PDP add flow in assets/pdp.js,
// but scoped to product-card quick-add forms — they cannot share the PDP's
// single `#product-form` id since a grid renders many cards. Loaded globally
// from layout/theme.liquid so it works on the homepage and collection pages.
document.addEventListener('submit', async (event) => {
	const form = event.target.closest('form[data-product-card-add]');
	if (!form) return;
	event.preventDefault();
	const btn = form.querySelector('.pcard__atc[data-shoppable]');
	if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
	const drawer = document.querySelector('cart-drawer');
	const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
	btn.classList.add('is-loading');
	btn.disabled = true;
	try {
		const body = new FormData(form);
		if (drawer?.dataset.sectionId) {
			body.append('sections', drawer.dataset.sectionId);
			body.append('sections_url', window.location.pathname);
		}
		const res = await fetch(`${root}cart/add.js`, {
			method: 'POST',
			headers: { Accept: 'application/json' },
			body,
		});
		const data = await res.json();
		if (!res.ok) throw new Error(data.description || data.message || 'Add to cart failed');
		// /cart/add.js returns the added line, not the cart — fetch the cart
		// for the fresh item_count, then reuse the drawer's own render().
		const cart = await (await fetch(`${root}cart.js`)).json();
		if (drawer) {
			drawer.render(
				{ sections: data.sections, item_count: cart.item_count },
				drawer.dataset.sectionId
			);
			drawer.open();
		}
		// Swap the label for a checkmark briefly, same affordance as pdp.js.
		const label = btn.querySelector('span');
		if (label) {
			// Capture the real label once; a rapid re-click must not capture the
			// checkmark SVG as the "original" (which would leave it stuck).
			if (btn._restoreTimer) {
				clearTimeout(btn._restoreTimer);
			} else {
				btn._originalLabel = label.innerHTML;
			}
			label.innerHTML =
				'<svg width="18" height="14" viewBox="0 0 18 14" fill="none" aria-hidden="true"><path d="M1 7.5L6.5 13L17 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
			btn._restoreTimer = setTimeout(() => {
				label.innerHTML = btn._originalLabel;
				btn._restoreTimer = null;
			}, 2000);
		}
	} catch (error) {
		console.error('[product-card] add to cart failed', error);
	} finally {
		btn.classList.remove('is-loading');
		btn.disabled = false;
	}
});
